(function($, undefined) {
	
	'use strict';
	var utils;
	var pageForm;
	var formValidator;
	var lc;

	var sumbitPageForm = function() {
		var form = $(this).closest('form');
		form.addClass('processing');
		formValidator.validateForm(form);
		
		if (!form.hasClass('has-error')) {
			var id = $('[name=id]', form).length > 0 ? $('[name=id]', form).val() : null;
			var userId = $('[name=user-id]', form).length > 0 ? $('[name=user-id]', form).val() : null;
			var title = $('[name=title]', form).val() != null > 0 ? $('[name=title]', form).val() : 'Titre de la page';
			var pageData = lc.getSnapshot(['shapes', 'colors']);

			var d = new Date();

			var month = d.getMonth()+1;
			var day = d.getDate();

			var formattedDate = ((''+day).length<2 ? '0' : '') + day + '/' +
			    ((''+month).length<2 ? '0' : '') + month + '/' +
			    d.getFullYear().toString().substr(-2);
			
			var action = "/action/manageGenData";
			var params = {
				ajax: true,
				field1: 'travel-book-page',
				field2: title,
				field3: JSON.stringify(pageData),
				field5: formattedDate,
				field6: userId
			};
			if (id) {
				params.id = id;
			}

			$.ajax({
				url: action,
				method: "post",
				data: params,
				complete: function(response) {
					if (response.responseText.indexOf('success') !== -1) {
						location.reload();
					} else {
						form.removeClass('processing');
					}
				}
			});
		} 
		else {
			form.removeClass('processing');
		}
	};

	var exportPage = function() {
		var pageData = lc.getImage();
		var image = pageData.toDataURL("image/png");

		var w=window.open('about:blank','Image du carnet');
		w.document.write("<img src='"+image+"' alt='Image du carnet'/>");
	};
	
	var init = function () {
		utils = Fw.component.models().utils;
		formValidator = Fw.component.models().form;
		pageForm = $('.page-edit-form');

		var id = $('[name=id]').length > 0 ? $('[name=id]').val() : null;

		if($('#lc').length > 0) {
			lc = LC.init(document.getElementById("lc"), {
		        imageURLPrefix: '/static/assets/img/lc-images',
		        toolbarPosition: 'top',
		        defaultStrokeWidth: 2,
		        strokeWidths: [1, 2, 3, 5, 30]
		      })
			
			utils.getGenData(id, function(response) {
				var pageData = $(response)[0].attributes.field3 ? $(response)[0].attributes.field3.value : "";
				
				if(pageData != '') {
					lc.loadSnapshot(JSON.parse(pageData));
				}
			});
		}


		$('.save-page-btn', pageForm).on('click', sumbitPageForm);
		$('.export-page-btn', pageForm).on('click', exportPage);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
